module.exports = __webpack_public_path__ + "static/media/animation.7c7b48fd.gif";